export default function Projects() {
  const projects = [
    {
      title: 'Instalaciones Eléctricas en Edificios',
      category: 'Ingeniería Eléctrica',
      description: 'Diseño e implementación de sistemas eléctricos completos para edificios corporativos y residenciales',
      image: 'https://public.readdy.ai/ai/img_res/294b4845ac10084fdfbfb7c6884c9c3c.jpg'
    },
    {
      title: 'Diseño Eléctrico para Industria',
      category: 'Proyectos Industriales',
      description: 'Soluciones eléctricas especializadas para plantas industriales y centros de producción',
      image: 'https://readdy.ai/api/search-image?query=industrial%20electrical%20design%20with%20power%20distribution%20systems%2C%20industrial%20electrical%20panels%20and%20control%20systems%2C%20modern%20factory%20electrical%20infrastructure%20with%20technical%20equipment%2C%20professional%20industrial%20installation%20with%20blue%20accents&width=800&height=600&seq=project-2-jdj&orientation=landscape'
    },
    {
      title: 'Proyectos Arquitectónicos',
      category: 'Arquitectura',
      description: 'Diseño arquitectónico integral para proyectos comerciales y residenciales de alto nivel',
      image: 'https://readdy.ai/api/search-image?query=modern%20architectural%20design%20project%20with%20detailed%20blueprints%20and%203D%20models%2C%20contemporary%20building%20architecture%20with%20clean%20lines%2C%20professional%20architectural%20workspace%20with%20technical%20drawings%20and%20plans%2C%20minimalist%20design%20with%20blue%20accents&width=800&height=600&seq=project-3-jdj&orientation=landscape'
    },
    {
      title: 'Supervisión Técnica de Obras',
      category: 'Ingeniería Integral',
      description: 'Gestión y supervisión técnica de proyectos de construcción e infraestructura',
      image: 'https://readdy.ai/api/search-image?query=construction%20site%20supervision%20with%20engineers%20reviewing%20technical%20plans%2C%20professional%20project%20management%20and%20quality%20control%2C%20modern%20construction%20site%20with%20technical%20equipment%20and%20safety%20standards%2C%20engineering%20oversight%20with%20blue%20hard%20hats&width=800&height=600&seq=project-4-jdj&orientation=landscape'
    }
  ];

  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Proyectos y <span className="text-blue-600">Experiencia</span>
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Experiencia comprobada en <strong>proyectos de ingeniería eléctrica</strong> y <strong>arquitectura</strong> en <strong>Lima</strong> y todo el <strong>Perú</strong>
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative w-full h-72 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-blue-600 text-white px-4 py-1.5 rounded-full text-sm font-medium">
                    {project.category}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{project.title}</h3>
                <p className="text-gray-600 leading-relaxed">{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}